import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import PersonsFormFields from './PersonsFormFields'

class PersonForm extends React.Component {

    render() {
        const {
            values,
            personType
        } = this.props;

        values.person_type = personType;

        return <PersonsFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            person_type: '',
            search_value: '',
            salutation: '',
            title: '',
            first_name: '',
            last_name: '',
            gender: '',
            birthday: '',
            citizenship: '',
            denomination: '',
            street: '',
            housenumber: '',
            zip: '',
            city: '',
            telephone: '',
            mobile: '',
            email: '',
            website: '',
            company_name: '',
            department: '',
            qualification_id: '',
            qualification: null,
        });
    },

    validationSchema: () => {
        let rules = object().shape({
            salutation: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.salutation')})
            ),
            first_name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
            ),
            last_name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')})
            ),
            street: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.street')})
            ),
            housenumber: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.housenumber')})
            ).max(
                5,
                i18n.get('validation.digits_between', {attribute: i18n.get('contacts.housenumber'), min: 1, max: 5})
            ),
            zip: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.zip')})
            ).max(
                5,
                i18n.get('validation.digits', {attribute: i18n.get('contacts.zip'), digits: 5})
            ).min(
                5,
                i18n.get('validation.digits', {attribute: i18n.get('contacts.zip'), digits: 5})
            ),
            city: string().required(
                i18n.get('validation.required', {attribute: i18n.get('contacts.city')})
            ),

        });

        return rules
    },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('contacts.save_success'),
                text: i18n.get('contacts.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('contacts.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(PersonForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Persons/PersonsForm.js